module.exports = __webpack_public_path__ + "img/2.ea84c242.png";